//Type Guards

import { CreateCustomerMutation, CreateVendorMutation, UpdateCustomerMutation, UpdateVendorMutation } from '../api/gql';

export const isCreateCustomerResponse = (
  res: CreateCustomerMutation | UpdateCustomerMutation,
): res is CreateCustomerMutation => {
  return !!(res as CreateCustomerMutation).createCustomer;
};

export const isCreateVendorResponse = (
  res: CreateVendorMutation | UpdateVendorMutation,
): res is CreateVendorMutation => {
  return !!(res as CreateVendorMutation).createVendor;
};
